import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const DropDownDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  padding: 17.6px;
  position: absolute;
  background: #ffffff;
  border: 2px solid #f05060;
  border-radius: 4px;
  max-width: 326.4px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.16);
  top: 275px;
  z-index: 10;
  cursor: default;
  text-align: left;

  &:after,
  &:before {
    bottom: 100%;
    left: 25%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #ffffff;
    border-width: 10px;
    margin-left: -10px;
    z-index: 10;
  }

  &:before {
    border-color: rgba(245, 0, 0, 0);
    border-bottom-color: #f05060;
    border-width: 13px;
    margin-left: -13px;
    z-index: 10;
  }
`;

class DropDownContainer extends Component {
  render() {
    return <DropDownDiv>{this.props.children}</DropDownDiv>;
  }
}

DropDownContainer.propTypes = {
  children: PropTypes.any
};

export default DropDownContainer;
